import { render, staticRenderFns } from "./SolutionInfoModal.vue?vue&type=template&id=16f22662&scoped=true&"
import script from "./SolutionInfoModal.vue?vue&type=script&lang=ts&"
export * from "./SolutionInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f22662",
  null
  
)

export default component.exports